module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "askMentor"
    }
  }, [_c('h1', [_vm._v("我要向 Mentor 提問")]), _vm._v(" "), _c('p', [_vm._v("註：Mentor 須在場並登入才會查看")]), _vm._v(" "), _c('p', [_vm._v("若能提供幫助，將至專案位置回答。")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form', {
    ref: "question",
    attrs: {
      "model": _vm.question,
      "label-position": "top",
      "label-width": "100px"
    }
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center",
      "align": "middle",
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8,
      "xs": 20
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "代表專案 編號",
      "prop": "projectId"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "專案編號（提案人編號）",
      "maxlength": 3
    },
    model: {
      value: (_vm.question.projectId),
      callback: function($$v) {
        _vm.question.projectId = $$v
      },
      expression: "question.projectId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "目標 Mentor 編號",
      "prop": "mentorId"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "請查看 Mentor 列表的編號",
      "maxlength": 3
    },
    model: {
      value: (_vm.question.mentorId),
      callback: function($$v) {
        _vm.question.mentorId = $$v
      },
      expression: "question.mentorId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "問題 主旨",
      "prop": "title"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "3至10字元",
      "maxlength": 10
    },
    model: {
      value: (_vm.question.title),
      callback: function($$v) {
        _vm.question.title = $$v
      },
      expression: "question.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "問題 簡介",
      "prop": "description"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "請簡短說明問題內容（100字以內）",
      "autosize": {
        minRows: 2,
        maxRows: 10
      },
      "maxlength": 100
    },
    model: {
      value: (_vm.question.description),
      callback: function($$v) {
        _vm.question.description = $$v
      },
      expression: "question.description"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.askQuestion()
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.resetQuestion()
      }
    }
  }, [_vm._v("清除")]), _vm._v(" "), _c('p', [_vm._v("登入才可以提交")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-411f9fe2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AskMentor.vue
// module id = 968
// module chunks = 1